/* eslint-disable import/no-cycle */
import { useContext } from 'react';

import { ContextMenuActionsContext } from 'contexts/context-menu-actions/ContextMenuActionsContext';

export const useContextMenuActions = () => {
  const contextMenuActionsState = useContext(ContextMenuActionsContext);
  return contextMenuActionsState;
};
